import * as React from "react"
import { Typography } from '@mui/material'


export default function userColumn() {
	return {
		name: 'username',
		label: 'Username',
		options: {
			customBodyRowRenderLite: value => <Typography sx={{ fontSize: '0.875rem' }}>
				{value || '-'}
			</Typography>
		}
	}
}